// Token manager to avoid circular dependencies
let accessToken = null;

export const tokenManager = {
  setToken: (token) => {
    accessToken = token;
    console.log('🎫 TokenManager: Access token stored');
  },
  
  getToken: () => {
    return accessToken;
  },
  
  clearToken: () => {
    accessToken = null;
    console.log('🗑️ TokenManager: Access token cleared');
  }
};

export default tokenManager; 